import CategoryList from "./CategoryList";
import CreateCategory from "./CreateCategory";

const Category = () => {
    return ( 
        <div>
            <CreateCategory />
            <CategoryList />
        </div>
     );
}
 
export default Category;